import { ZipContextState, ZipProjectActionsEnum, ZipProjectAction } from "./interfaces";

export const zipProjectReducer: React.Reducer<ZipContextState, ZipProjectAction> = (state, action) => {
  switch (action.type) {
    case ZipProjectActionsEnum.ApplyFilters:
      return {
        ...state,
        hasExpandableSpecialties: action.payload.hasExpandableSpecialties,
        isDrilledIn: action.payload.isDrilledIn,
        loading: action.payload.loading,
        regionSetIds: action.payload.regionSetIds,
        regionSetSpecialtyGroupToPartsMap: action.payload.regionSetSpecialtyGroupToPartsLookup,
        selectedRows: action.payload.selectedRows,
        shouldRefreshNetworkProviders: action.payload.shouldRefreshNetworkProviders,
        shouldShowSummariesTab: action.payload.shouldShowSummariesTab,
        skip: action.payload.skip,
        totalNumberOfRecords: action.payload.totalNumberOfRecords,
        trendChartData: action.payload.trendChartData,
        urlSearchString: action.payload.urlSearchString,
        zipClassDrillInDetails: action.payload.zipClassDrillInDetails,
        zipDetails: action.payload.zipDetails,
        zipDetailsCompared: action.payload.zipDetailsCompared,
        zipExpansions: action.payload.zipExpansions,
        zipExpansionsCompared: action.payload.zipExpansionsCompared,
      };
    case ZipProjectActionsEnum.ChangeChangedGapsFilter:
      return {
        ...state,
        adequacyFilters: action.payload.adequacyFilters,
        hasExpandableSpecialties: action.payload.hasExpandableSpecialties,
        isDrilledIn: action.payload.isDrilledIn,
        loading: action.payload.loading,
        regionSetIds: action.payload.regionSetIds,
        regionSetSpecialtyGroupToPartsLookup: action.payload.regionSetSpecialtyGroupToPartsLookup,
        selectedRows: action.payload.selectedRows,
        totalNumberOfRecords: action.payload.totalNumberOfRecords,
        urlSearchString: action.payload.urlSearchString,
        zipDetails: action.payload.zipDetails,
        zipDetailsCompared: action.payload.zipDetailsCompared,
        zipExpansions: action.payload.zipExpansions,
        zipExpansionsCompared: action.payload.zipExpansionsCompared,
      };
    case ZipProjectActionsEnum.ChangeCheckbox:
      return {
        ...state,
        selectedRows: action.payload.selectedRows,
      };
    case ZipProjectActionsEnum.ChangeCompareToProjectRunConfiguration:
      return {
        ...state,
        calculationMethod: action.payload.calculationMethod,
        calculationMethodCompared: action.payload.calculationMethodCompared,
        compareToRunConfiguration: action.payload.compareToRunConfiguration,
        filterOptions: action.payload.filterOptions,
        filterSelections: action.payload.filterSelections,
        hasExpandableSpecialties: action.payload.hasExpandableSpecialties,
        isCompareMode: action.payload.isCompareMode,
        isDrilledIn: action.payload.isDrilledIn,
        loading: action.payload.loading,
        regionSetIds: action.payload.regionSetIds,
        regionSetSpecialtyGroupToPartsLookup: action.payload.regionSetSpecialtyGroupToPartsLookup,
        selectedRows: action.payload.selectedRows,
        shouldShowSummariesTab: action.payload.shouldShowSummariesTab,
        skip: action.payload.skip,
        sortOption: action.payload.sortOption,
        templateMetadataCompared: action.payload.templateMetadataCompared,
        totalNumberOfRecords: action.payload.totalNumberOfRecords,
        trendChartData: action.payload.trendChartData,
        urlSearchString: action.payload.urlSearchString,
        zipDetails: action.payload.zipDetails,
        zipDetailsCompared: action.payload.zipDetailsCompared,
        zipExpansions: action.payload.zipExpansions,
        zipExpansionsCompared: action.payload.zipExpansionsCompared,
      };
    case ZipProjectActionsEnum.ChangeFilter:
      return {
        ...state,
        filterSelections: action.payload.filterSelections,
      };
    case ZipProjectActionsEnum.ChangePage:
      return {
        ...state,
        hasExpandableSpecialties: action.payload.hasExpandableSpecialties,
        loading: false,
        regionSetSpecialtyGroupToPartsLookup: action.payload.regionSetSpecialtyGroupToPartsLookup,
        skip: action.payload.skip,
        totalNumberOfRecords: action.payload.totalNumberOfRecords,
        zipDetails: action.payload.zipDetails,
        zipDetailsCompared: action.payload.zipDetailsCompared,
        zipExpansions: action.payload.zipExpansions,
        zipExpansionsCompared: action.payload.zipExpansionsCompared,
      };
    case ZipProjectActionsEnum.ChangeMemberships:
      return {
        ...state,
        compareToRunConfiguration: action.payload.compareToRunConfiguration,
        dualMembershipRunConfiguration: action.payload.dualMembershipRunConfiguration,
        isCompareMode: action.payload.isCompareMode,
        isDualMembershipMode: action.payload.isDualMembershipMode,
        loading: action.payload.loading,
        runConfiguration: action.payload.runConfiguration,
      };
    case ZipProjectActionsEnum.ChangePerspectiveZipClass:
    case ZipProjectActionsEnum.ChangePerspectiveZipCode:
      return {
        ...state,
        adequacyFilters: action.payload.adequacyFilters,
        calculationMethod: action.payload.calculationMethod,
        calculationMethodCompared: action.payload.calculationMethodCompared,
        dualMembershipRunConfiguration: action.payload.dualMembershipRunConfiguration,
        filterOptions: action.payload.filterOptions,
        filterSelections: action.payload.filterSelections,
        hasExpandableSpecialties: action.payload.hasExpandableSpecialties,
        isDrilledIn: action.payload.isDrilledIn,
        isDualMembershipMode: action.payload.isDualMembershipMode,
        loading: action.payload.loading,
        perspective: action.payload.perspective,
        project: action.payload.project,
        regionSetIds: action.payload.regionSetIds,
        regionSetSpecialtyGroupToPartsLookup: action.payload.regionSetSpecialtyGroupToPartsLookup,
        runConfiguration: action.payload.runConfiguration,
        selectedRows: action.payload.selectedRows,
        setShouldRefreshNetworkProviders: action.payload.setShouldRefreshNetworkProviders,
        shouldShowSummariesTab: action.payload.shouldShowSummariesTab,
        skip: action.payload.skip,
        sortOption: action.payload.sortOption,
        templateMetadata: action.payload.templateMetadata,
        totalNumberOfRecords: action.payload.totalNumberOfRecords,
        trendChartData: action.payload.trendChartData,
        urlPathnameString: action.payload.urlPathnameString,
        urlSearchString: action.payload.urlSearchString,
        zipClassDrillInDetails: action.payload.zipClassDrillInDetails,
        zipDetails: action.payload.zipDetails,
        zipDetailsCompared: action.payload.zipDetailsCompared,
        zipExpansions: action.payload.zipExpansions,
        zipExpansionsCompared: action.payload.zipExpansionsCompared,
      }
    case ZipProjectActionsEnum.ChangeProjectStatus:
      return {
        ...state,
        filterOptions: action.payload.filterOptions,
        filterSelections: action.payload.filterSelections,
        hasExpandableSpecialties: action.payload.hasExpandableSpecialties,
        isDrilledIn: action.payload.isDrilledIn,
        loading: action.payload.loading,
        project: action.payload.project,
        regionSetIds: action.payload.regionSetIds,
        regionSetSpecialtyGroupToPartsLookup: action.payload.regionSetSpecialtyGroupToPartsLookup,
        runConfiguration: action.payload.runConfiguration,
        selectedRows: action.payload.selectedRows,
        skip: action.payload.skip,
        templateMetadata: action.payload.templateMetadata,
        totalNumberOfRecords: action.payload.totalNumberOfRecords,
        trendChartData: action.payload.trendChartData,
        urlSearchString: action.payload.urlSearchString,
        zipDetails: action.payload.zipDetails,
        zipDetailsCompared: action.payload.zipDetailsCompared,
        zipExpansions: action.payload.zipExpansions,
        zipExpansionsCompared: action.payload.zipExpansionsCompared,
      };
    case ZipProjectActionsEnum.ChangeProjectRunConfiguration:
      return {
        ...state,
        calculationMethod: action.payload.calculationMethod,
        calculationMethodCompared: action.payload.calculationMethodCompared,
        dualMembershipRunConfiguration: action.payload.dualMembershipRunConfiguration,
        filterOptions: action.payload.filterOptions,
        filterSelections: action.payload.filterSelections,
        hasExpandableSpecialties: action.payload.hasExpandableSpecialties,
        isDrilledIn: action.payload.isDrilledIn,
        isDualMembershipMode: action.payload.isDualMembershipMode,
        loading: action.payload.loading,
        regionSetIds: action.payload.regionSetIds,
        regionSetSpecialtyGroupToPartsLookup: action.payload.regionSetSpecialtyGroupToPartsLookup,
        runConfiguration: action.payload.runConfiguration,
        selectedRows: action.payload.selectedRows,
        shouldShowSummariesTab: action.payload.shouldShowSummariesTab,
        skip: action.payload.skip,
        sortOption: action.payload.sortOption,
        templateMetadata: action.payload.templateMetadata,
        totalNumberOfRecords: action.payload.totalNumberOfRecords,
        trendChartData: action.payload.trendChartData,
        urlSearchString: action.payload.urlSearchString,
        zipDetails: action.payload.zipDetails,
        zipDetailsCompared: action.payload.zipDetailsCompared,
        zipExpansions: action.payload.zipExpansions,
        zipExpansionsCompared: action.payload.zipExpansionsCompared,
      };
    case ZipProjectActionsEnum.ClickSpecialtyGroupOrZipCode:
      return {
        ...state,
        filterSelections: action.payload.filterSelections,
        hasExpandableSpecialties: action.payload.hasExpandableSpecialties,
        isDrilledIn: action.payload.isDrilledIn,
        loading: action.payload.loading,
        regionSetIds: action.payload.regionSetIds,
        regionSetSpecialtyGroupToPartsLookup: action.payload.regionSetSpecialtyGroupToPartsLookup,
        selectedRows: action.payload.selectedRows,
        shouldRefreshNetworkProviders: action.payload.shouldRefreshNetworkProviders,
        shouldShowSummariesTab: action.payload.shouldShowSummariesTab,
        skip: action.payload.skip,
        sortOption: action.payload.sortOption,
        totalNumberOfRecords: action.payload.totalNumberOfRecords,
        trendChartData: action.payload.trendChartData,
        urlSearchString: action.payload.urlSearchString,
        zipClassDrillInDetails: action.payload.zipClassDrillInDetails,
        zipDetails: action.payload.zipDetails,
        zipDetailsCompared: action.payload.zipDetailsCompared,
        zipExpansions: action.payload.zipExpansions,
        zipExpansionsCompared: action.payload.zipExpansionsCompared,
      };
    case ZipProjectActionsEnum.EditProject:
      return {
        ...state,
        hasExpandableSpecialties: action.payload.hasExpandableSpecialties,
        loading: action.payload.loading,
        project: action.payload.project,
        regionSetSpecialtyGroupToPartsLookup: action.payload.regionSetSpecialtyGroupToPartsLookup,
        runConfiguration: action.payload.runConfiguration,
        templateMetadata: action.payload.templateMetadata,
        totalNumberOfRecords: action.payload.totalNumberOfRecords,
        zipDetails: action.payload.zipDetails,
        zipDetailsCompared: action.payload.zipDetailsCompared,
        zipExpansions: action.payload.zipExpansions,
        zipExpansionsCompared: action.payload.zipExpansionsCompared,
      };
    case ZipProjectActionsEnum.EditTimeslicePublishComment:
      return {
        ...state,
        trendChartData: action.payload.trendChartData,
      };
    case ZipProjectActionsEnum.Error:
      return {
        ...state,
        ...action.payload,
        error: action.payload.error,
        loading: false,
        project: state.project,
      };
    case ZipProjectActionsEnum.Loading:
      return {
        ...state,
        loading: true,
      };
    case ZipProjectActionsEnum.LoadProjectWithoutRunConfiguration:
      return {
        ...state,
        loading: action.payload.loading,
        project: action.payload.project,
      };
    case ZipProjectActionsEnum.PublishProjectRunConfiguration:
      return {
        ...state,
        loading: action.payload.loading,
        project: action.payload.project,
        runConfiguration: action.payload.runConfiguration,
        templateMetadata: action.payload.templateMetadata,
        trendChartData: action.payload.trendChartData,
      };
    case ZipProjectActionsEnum.NavigateHistory:
      return {
        ...state,
        adequacyFilters: action.payload.adequacyFilters,
        filterOptions: action.payload.filterOptions,
        filterSelections: action.payload.filterSelections,
        hasExpandableSpecialties: action.payload.hasExpandableSpecialties,
        isDrilledIn: action.payload.isDrilledIn,
        loading: action.payload.loading,
        module: action.payload.module,
        perspective: action.payload.perspective,
        regionSetSpecialtyGroupToPartsLookup: action.payload.regionSetSpecialtyGroupToPartsLookup,
        shouldRefreshNetworkProviders: action.payload.shouldRefreshNetworkProviders,
        shouldShowSummariesTab: action.payload.shouldShowSummariesTab,
        totalNumberOfRecords: action.payload.totalNumberOfRecords,
        trendChartData: action.payload.trendChartData,
        urlSearchString: action.payload.urlSearchString,
        zipDetails: action.payload.zipDetails,
        zipDetailsCompared: action.payload.zipDetailsCompared,
        zipExpansions: action.payload.zipExpansions,
        zipExpansionsCompared: action.payload.zipExpansionsCompared,
      };
    case ZipProjectActionsEnum.RenderedNetworkProviders:
      return {
        ...state,
        shouldRefreshNetworkProviders: action.payload.shouldRefreshNetworkProviders,
      };
    case ZipProjectActionsEnum.ResetFilters:
      return {
        ...state,
        filterSelections: action.payload.filterSelections,
        hasExpandableSpecialties: action.payload.hasExpandableSpecialties,
        isDrilledIn: action.payload.isDrilledIn,
        loading: action.payload.loading,
        regionSetIds: action.payload.regionSetIds,
        regionSetSpecialtyGroupToPartsMap: action.payload.regionSetSpecialtyGroupToPartsLookup,
        selectedRows: action.payload.selectedRows,
        shouldRefreshNetworkProviders: action.payload.shouldRefreshNetworkProviders,
        shouldShowSummariesTab: action.payload.shouldShowSummariesTab,
        skip: action.payload.skip,
        sortOption: action.payload.sortOption,
        totalNumberOfRecords: action.payload.totalNumberOfRecords,
        trendChartData: action.payload.trendChartData,
        urlSearchString: action.payload.urlSearchString,
        zipClassDrillInDetails: action.payload.zipClassDrillInDetails,
        zipDetails: action.payload.zipDetails,
        zipDetailsCompared: action.payload.zipDetailsCompared,
        zipExpansions: action.payload.zipExpansions,
        zipExpansionsCompared: action.payload.zipExpansionsCompared,
      };
    case ZipProjectActionsEnum.SortTable:
      return {
        ...state,
        hasExpandableSpecialties: action.payload.hasExpandableSpecialties,
        loading: false,
        regionSetSpecialtyGroupToPartsLookup: action.payload.regionSetSpecialtyGroupToPartsLookup,
        skip: action.payload.skip,
        sortOption: action.payload.sortOption,
        totalNumberOfRecords: action.payload.totalNumberOfRecords,
        zipDetails: action.payload.zipDetails,
        zipDetailsCompared: action.payload.zipDetailsCompared,
        zipExpansions: action.payload.zipExpansions,
        zipExpansionsCompared: action.payload.zipExpansionsCompared,
      };
    case ZipProjectActionsEnum.StartRunProject:
      return {
        ...state,
        filterSelections: action.payload.filterSelections,
        isDrilledIn: action.payload.isDrilledIn,
        project: action.payload.project,
        regionSetIds: action.payload.regionSetIds,
        regionSetSpecialtyGroupToPartsLookup: action.payload.regionSetSpecialtyGroupToPartsLookup,
        selectedRows: action.payload.selectedRows,
        skip: action.payload.skip,
        sortOption: action.payload.sortOption,
        urlPathnameString: action.payload.urlPathnameString,
        urlSearchString: action.payload.urlSearchString,
        zipDetails: action.payload.zipDetails,
        zipExpansions: action.payload.zipExpansions,
      };
    case ZipProjectActionsEnum.ProcessProviderChanges:
    case ZipProjectActionsEnum.ResetStatusBanners:
      return {
        ...state,
        project: action.payload.project
      };
    default:
      return state;
    }
}